/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'

import { makeStyles } from 'tss-react/mui';

const TosPage = () => {

    const { classes } = useStyles()
    return (
        <>
            <Grid container spacing={4} className={classes.paper}>
                <Grid item xs={12} sm={12} md={3} />
                <Grid item xs={12} sm={12} md={6}>

                
                </Grid>
            </Grid>




        </>
    )

}
const useStyles = makeStyles({ "name": { TosPage } })(theme => ({
    paper: {
        background: 'rgba(0, 0, 0, 0.5)',
    },
    typestyle: {
        lineHeight: '2.5em!important',
    },
    subtypestyle: {
        lineHeight: '2em!important',
    },
}))

TosPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
    return {}
}

const styledTosPage = TosPage
const connectedTosPage = connect(mapStateToProps)(styledTosPage)
export { connectedTosPage as TosPage }
